import type { TOC } from '@ember/component/template-only';
import { on } from '@ember/modifier';
import { PrismIcon } from '@mylighthouse/prism-ember';

interface HotelStrategyEmptyMetricBlockSignature {
  Args: {
    canRedirect: unknown;
    iconName: unknown;
    label: unknown;
    redirectAction: unknown;
  };
}

const HotelStrategyEmptyMetricBlock = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{! template-lint-disable link-href-attributes require-presentational-children }}
  <div
    class="rate-strategy-subtype-metric-block rate-strategy-subtype-metric-block--dashed flex items-center justify-center"
  >
    {{#if @canRedirect}}
      <a
        class="prism-link flex justify-center gap-100"
        role="button"
        {{on "click" @redirectAction}}
      >
        <PrismIcon @color="inherit" @name={{@iconName}} />
        <p class="text-300--regular">{{@label}}</p>
      </a>
    {{else}}
      <div class="flex items-center gap-100">
        <PrismIcon @name={{@iconName}} />
        <p class="text-300--regular">{{@label}}</p>
      </div>
    {{/if}}
  </div>
</template> satisfies TOC<HotelStrategyEmptyMetricBlockSignature>;

export default HotelStrategyEmptyMetricBlock;
